import Route from '../Route'
import { CustomSwitch } from '../../components/CustomSwitch'
import InvoicesIssuedForCnpjList from 'pages/Financial/InvoicesIssuedForCnpj/List'

export const InvoicesIssuedForCnpjRouter = (): JSX.Element => (
  <CustomSwitch>
    <Route
      path="/financial/invoicesIssuedForCnpj"
      exact
      component={InvoicesIssuedForCnpjList}
    />
  </CustomSwitch>
)
